export default {
  namespaced: true,
  state: {
    shareLabel: '',
    shareButtonLabel: '',
    shareButtonResultText: '',
    shareEmailSubject: ''
  },
  mutations: {
    changeShareLabel(state, payload) {
      state.shareLabel = payload
    },
    changeShareButtonLabel(state, payload) {
      state.shareButtonLabel = payload
    },
    changeShareButtonResultText(state, payload) {
      state.shareButtonResultText = payload
    },
    changeShareEmailSubject(state, payload) {
      state.shareEmailSubject = payload
    }
  },
  actions: {
    changeShareLabel({ commit }, payload) {
      commit('changeShareLabel', payload)
    },
    changeShareButtonLabel({ commit }, payload) {
      commit('changeShareButtonLabel', payload)
    },
    changeShareButtonResultText({ commit }, payload) {
      commit('changeShareButtonResultText', payload)
    },
    changeShareEmailSubject({ commit }, payload) {
      commit('changeShareEmailSubject', payload)
    }
  },
  getters: {
    shareLabel: state => state.shareLabel,
    shareButtonLabel: state => state.shareButtonLabel,
    shareButtonResultText: state => state.shareButtonResultText,
    shareEmailSubject: state => state.shareEmailSubject
  }
}
